import * as token from "@universityofmaryland/web-token-library";
import { createMediaQuery } from "@universityofmaryland/web-utilities-library/styles";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/accessibility";
import "../../atomic/animations/brand/card-stack.js";
import { createImageBackground } from "../../atomic/assets/image/background.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import { image, textContainer, container } from "../../atomic/layout/block/stacked.js";
import "../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../atomic/text-lockup/small.js";
import { createTextLockupSmallScaling } from "../../atomic/text-lockup/small-scaling.js";
const smallBreakpoint = token.media.breakpointValues.small.max;
const createCompositeCardBlock = (props) => {
  const {
    dateSign,
    hasBorder,
    hasEyebrowRibbon,
    image: image$1,
    imageLoading = "lazy",
    isAligned,
    isThemeDark,
    isTransparent,
    newsId
  } = props;
  const shouldImageBeFullWidth = hasEyebrowRibbon;
  const children = [];
  const sizingProps = {
    isThemeDark,
    isTransparent,
    hasBorder
  };
  if (image$1) {
    children.push(
      image({
        children: [
          createImageBackground({
            element: image$1,
            isScaled: true,
            isAspectStandard: isAligned,
            dateSign,
            imageLoading
          })
        ],
        customStyles: {
          ...shouldImageBeFullWidth && {
            ...createMediaQuery("max-width", smallBreakpoint, {
              marginBottom: token.spacing.md,
              width: "100%"
            })
          }
        },
        ...sizingProps
      })
    );
  }
  children.push(
    textContainer({
      children: [createTextLockupSmallScaling(props)],
      ...sizingProps,
      hasImage: !!image$1
    })
  );
  const composite = container({
    children,
    ...sizingProps
  });
  if (newsId) {
    composite?.element.setAttribute("news-id", newsId);
  }
  return composite;
};
export {
  createCompositeCardBlock
};
//# sourceMappingURL=block.js.map
